import axios from 'axios';
import utils from './functions-base/utils';

declare let auth_object: any;

// Utils
const modUtils = new utils();

export default class authVerifyToken{

    protected elBox: string;
    protected elFormSpin: string = 'bgdrop-spin';
    protected url_api_verify_token: string;

    /**
     * Constructor
     * @param elBox 
     */
    constructor(
        elBox: string,
    ){
        
        this.elBox = elBox;
        this.url_api_verify_token = auth_object.rest_urls.auth_verify_token;

    }

    checkToken(){
        
        const _that = this;
    
        const box = document.querySelector(this.elBox) as HTMLElement | null;

        if(box != null){
            
            const searchParams = new URLSearchParams(window.location.search);

            const get_token = searchParams.get('token-auth-activate') as string;

            const post_data = {
                'token': get_token,
            };
    
            const queryString = new URLSearchParams(post_data).toString();

            // Init spin
            const spin = modUtils.btnSpin(this.elFormSpin);

            box?.append(spin);
            
            // Call ajax
            axios.post(this.url_api_verify_token, queryString)
                .then(function (response: any){

                spin.remove();
                    
                box.classList.remove('bg-green-700', 'border-green-800', 'bg-red-700', 'border-red-800');

                const responseStatus: boolean = response.data.status;
                    
                if(responseStatus == true){
                    
                    box.classList.add('bg-green-700', 'border-green-800');
                    
                }else{
                    
                    box.classList.add('bg-red-700', 'border-red-800');

                }

                const message = response.data.message;
                    
                box.prepend(message);

            })
            .catch(function (error:any){

                spin.remove();

                const message = auth_object.error_messages.general;
                    
                box.prepend(message);
                

            });
        
        }
    
    
    }

}